module.exports = __webpack_public_path__ + "images/abs-lender-facility-reconciliation.a6bc0c36c57ed1ba16b28c3a5ebb2fd0.svg";